import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

// Link grup WhatsApp & Google Classroom untuk kelas yang sedang berjalan.
// Admin menggantinya manual setiap pergantian kelas; student yang terdaftar
// di kelas berjalan melihatnya sebagai tombol di Student Portal.
const ClassLinksCard = () => {
  const [saved, setSaved] = useState({ classroomUrl: "", whatsappUrl: "" });
  const [whatsappUrl, setWhatsappUrl] = useState("");
  const [classroomUrl, setClassroomUrl] = useState("");
  const [context, setContext] = useState({ currentClass: null, currentBatch: null });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const apply = (data) => {
    const next = { classroomUrl: data.classroomUrl || "", whatsappUrl: data.whatsappUrl || "" };
    setSaved(next);
    setClassroomUrl(next.classroomUrl);
    setWhatsappUrl(next.whatsappUrl);
    setContext({ currentClass: data.currentClass, currentBatch: data.currentBatch });
  };

  useEffect(() => {
    axios
      .get("/class-join-links")
      .then((res) => apply(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const dirty = whatsappUrl.trim() !== saved.whatsappUrl || classroomUrl.trim() !== saved.classroomUrl;

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await axios.put("/class-join-links", { whatsappUrl, classroomUrl });
      apply(res.data);
      Swal.fire({
        text: "Links saved. Students in the running class will see the new links in the Student Portal.",
        icon: "success",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
        timer: 2200,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        text: err.response?.data?.msg || "Failed to save the links.",
        icon: "error",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
      });
    } finally {
      setSaving(false);
    }
  };

  const runningText = context.currentClass
    ? `${context.currentClass}${context.currentBatch ? ` · Batch ${context.currentBatch}` : ""}`
    : context.currentBatch
      ? `Batch ${context.currentBatch}`
      : null;

  return (
    <section className="adm-card" style={{ marginTop: "24px" }}>
      <div className="adm-card-header">
        <div>
          <h2 className="adm-card-title">Class Links</h2>
          <p className="adm-card-subtitle">
            WhatsApp group & Google Classroom for the running class{runningText ? ` (${runningText})` : ""}. Update
            them when the class changes.
          </p>
        </div>
      </div>
      <form className="adm-card-body" onSubmit={save}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label" htmlFor="cl-whatsapp" style={{ fontWeight: 600, fontSize: "13.5px" }}>
              <i className="bi bi-whatsapp" style={{ color: "#1fa855", marginRight: "6px" }}></i>
              WhatsApp group link
            </label>
            <input
              id="cl-whatsapp"
              type="url"
              className="form-control"
              placeholder="https://chat.whatsapp.com/…"
              value={whatsappUrl}
              onChange={(e) => setWhatsappUrl(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="cl-classroom" style={{ fontWeight: 600, fontSize: "13.5px" }}>
              <i className="bi bi-mortarboard" style={{ marginRight: "6px" }}></i>
              Google Classroom link
            </label>
            <input
              id="cl-classroom"
              type="url"
              className="form-control"
              placeholder="https://classroom.google.com/c/…"
              value={classroomUrl}
              onChange={(e) => setClassroomUrl(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap" style={{ marginTop: "16px" }}>
          <p className="adm-help" style={{ margin: 0 }}>
            Leave a field empty to hide that button. The Excuse Form button is always shown.
          </p>
          <button type="submit" className="adm-btn adm-btn--primary" disabled={loading || saving || !dirty}>
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default ClassLinksCard;
